'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var Panel = require('@narvar/nth-block-panel');
var Asset_module = require('./Asset.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);

const Asset = ({
  featureName,
  assetId,
  asset,
  fixedPanelHeight,
  templateRenderingContext
}) => {
  const {
    imgPrimaryNone: imgStyle,
    assetpanelcontainerNoneNone: containerStyle,
    panelcontainerNoneNone: {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  } = nthHookTheme.useTheme();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const baseLogInfo = {
    feature: featureName,
    pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_ASSET,
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_ASSET,
    eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_ASSET
  };
  React.useEffect(() => {
    if (!assetId || !asset) return;
    const {
      category,
      altText,
      cdnUrl,
      name
    } = asset;
    logEvent({
      ...baseLogInfo,
      clickAssetId: assetId,
      clickAssetType: category,
      clickAssetUrl: cdnUrl || '',
      clickLinkLabel: name || altText,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [assetId]);
  if (!asset) return null;
  const {
    category,
    destinationUrl,
    altText,
    cdnUrl
  } = asset;
  if (!cdnUrl) return null;
  const renderedDestinationUrl = mustache__default["default"].render(destinationUrl || '', templateRenderingContext);
  const img = fixedPanelHeight ? /*#__PURE__*/React__default["default"].createElement("div", {
    role: "img",
    "aria-label": altText || '',
    className: Asset_module["default"].container,
    style: {
      backgroundImage: `url(${cdnUrl})`,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      ...imgStyle
    }
  }) : /*#__PURE__*/React__default["default"].createElement("img", {
    src: cdnUrl,
    alt: altText || '',
    "data-testid": "blockAssetImage",
    className: Asset_module["default"].image,
    style: {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      ...imgStyle
    }
  });
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    sOuter: {
      ...containerStyle,
      overflowY: 'visible',
      boxSizing: 'border-box',
      height: fixedPanelHeight || containerStyle && containerStyle.height || '100%'
    },
    sInner: {
      overflowY: 'visible',
      padding: 0
    },
    header: true
  }, destinationUrl ? /*#__PURE__*/React__default["default"].createElement("a", {
    className: Asset_module["default"].link,
    href: renderedDestinationUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    },
    onClick: () => logEvent({
      ...baseLogInfo,
      clickAssetId: assetId,
      clickAssetType: category,
      clickAssetUrl: cdnUrl,
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.MARKETING_ASSET,
      clickLinkDestinationUrl: renderedDestinationUrl,
      clickLinkLabel: altText,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.MARKETING_ASSET,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK
    })
  }, img) : img);
};
var Asset$1 = nthHookTheme.withThemeProvider(Asset, {
  themeTokens: ['imgPrimaryNone', 'assetpanelcontainerNoneNone', 'panelcontainerNoneNone']
});

exports["default"] = Asset$1;
